<template>
    <div v-if="error" class="wp-10">
        <div class="placeholder">
            <p class="acenter">
                {{
                    $l10n.__('Une erreur est survenue, veuillez réinitialiser la liste des filtres')
                }}
            </p>
            <CompassButton
                :label="$t.__('common.actions.reset')"
                @click="$store.dispatch(`${listinghash}/resetFilters`)"
            />
        </div>
    </div>
    <div v-else class="steps-container">
        <pipeline-step
            v-for="step in funnel.steps"
            :key="step.id"
            :stepData="step"
            :listinghash="listinghash"
            :opps="rows[step.id]"
            @opportunity-update="updateStep"
            @opportunity-update-header="updateHeaderStep"
        >
        </pipeline-step>
    </div>
</template>

<script>
import PipelineStep from './PipelineStep.vue';

export default {
    components: {
        PipelineStep,
    },
    props: {
        listinghash: {
            type: String,
        },
    },
    computed: {
        rows() {
            return this.$store.state[this.listinghash].rows;
        },

        funnel() {
            return this.$store.state[this.listinghash].funnel;
        },
        error() {
            return this.$store.state[this.listinghash].error;
        },
    },
    methods: {
        updateStep(oid, stepid, newRank, prevOpps, payload) {
            // AJAX call to update opportunity rank in database + in store
            window.axios
                .get('/prospection/pipeline/updaterank', {
                    params: {
                        oid,
                        stepid,
                        newRank,
                        prevOpps,
                    },
                })
                .then((response) => {
                    this.$store.dispatch(`${this.listinghash}/updateStep`, {
                        rows: payload,
                        stepid: stepid,
                    });
                    if (response.data.processAutomationStepEnter === 'Y') {
                        window.Opportunity.askProcessAutomationStepEnter(oid);
                    }
                    Push.success(
                        this.$l10n.__('Opportunité déplacée dans la nouvelle étape du pipeline.'),
                        this.$l10n.__('Message système'),
                    );
                })
                .catch((error) => {
                    if (error.response && error.response.status && error.response.status == 403) {
                        Push.error(
                            this.$l10n.__(
                                'Vous ne disposez pas des droits nécessaires pour cette action.',
                            ),
                        );
                    } else {
                        // handle error
                        Push.error(
                            this.$l10n.__(
                                "Une erreur s'est produite lors du déplacement de l'opportunité. Veuillez ré-essayer dans quelques minutes.",
                            ),
                            this.$l10n.__('Erreur'),
                        );
                    }
                });
        },
        updateHeaderStep(payload) {
            this.$store.dispatch(`${this.listinghash}/updateHeaderStep`, {
                payload: payload,
            });
        },
    },
};
</script>

<style lang="sass" scoped>
.steps-container{
    flex:1;
    display:flex;
    align-items:stretch;
}
</style>
